import apiService from "./api";

export const updateProfile = (formData: Record<string, any>) => {
  return apiService(`/core/update-profile/`, "PUT", formData, true, {
    "Content-Type": "multipart/form-data",
  });
};

export const resetPassword = (
  current_password: string,
  new_password: string,
  confirm_password: string
) => {
  return apiService(
    `/core/changePassword/`,
    "POST",
    {
      current_password,
      new_password,
      confirm_password,
    },
    true
  );
};
